import { type IconTypes } from '@procurify/ui'

import { type Enum } from '@webapp/infrastructure/types/Enum'

export const CatalogItemTagIcons = {
  CATALOG: 'catalog',
  PREVIOUS_ORDER: 'previous_order',
  OVER_BUDGET: 'over_budget',
} as const

export type CatalogItemTagIcon = Enum<typeof CatalogItemTagIcons>

// Right now, FE will determin the structure of components
// But later on we may want to switch to arbitrary icons from LLM
export const CatalogItemTagIconMap: Record<CatalogItemTagIcon, IconTypes> = {
  [CatalogItemTagIcons.CATALOG]: 'catalog',
  [CatalogItemTagIcons.PREVIOUS_ORDER]: 'action-history',
  [CatalogItemTagIcons.OVER_BUDGET]: 'attention',
}
